export const ComposerFragment: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}): JSX.Element => <>{children}</>;
